import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';

import { usePartner } from 'components/app/routes/usePartner';
import { addHash } from 'machines/utils/misc';

export const useOnExit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { partnerName } = usePartner();

  useEffect(() => {
    const onExit = () => {
      const state = {
        partnerName
      };
      const currentFullPath = addHash(
        `${location.pathname}${location.search}`,
        location.hash
      );

      //save state (partnerName) to history for current path before exiting the app
      navigate(currentFullPath, { replace: true, state });
    };
    window.addEventListener('pagehide', onExit);

    return () => {
      window.removeEventListener('pagehide', onExit);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
